// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3_fK6","info":"Note_info__2uUwQ","note":"Note_note__1QFM3","actions":"Note_actions__2K225"};